// removed by extract-text-webpack-plugin
module.exports = {"container":"_2sMCYC0DFOh6Mc2e4Ygifp","pickBtn":"_3EJmuRYXWWQg5OyiLcQ9sG"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Settings/Signature/Upload/styles.css
// module id = 2561
// module chunks = 0